import styled from "styled-components";

import { theme } from "../../../themes/themes";
export const GeneralStyle = styled.div`
  padding: 1rem;
  opacity: 1;
  h1 {
    grid-row: 1;
    text-align: left;
    color: ${({ theme }) => theme.primaryLight};
    margin: 0 0 0 15px;
    font-size: 1.5em;
  }
`;

export const FormCard = styled.div`
  width: 50vw;
  height: auto;
  font-size: 14px;
  border: 1px solid ${({ theme }) => theme.primaryLight};
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  background: ${({ theme }) => theme.neutral.white};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: minmax(5em, auto);
  box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primaryLight};
  @media only screen and (max-width: 768px) {
    width: 80%;
  }
  svg {
    grid-row: 1;
    right: 15px;
    cursor: pointer;
    fill: red;
    transition: all ease 0.5s;
    align-self: center;
  }

  svg:hover {
    stroke: ${({ theme }) => theme.button.primary};
    stroke-width: 2px;
  }

  hr {
    width: 100%;
    grid-column: 1 / 3;
  }

  button {
    grid-row: 6;
    align-self: center;
    justify-self: right;
    margin-right: 0.4rem;
    width: 9rem;
    height: 2rem;
    outline: 0;
    padding: 6px 12px;
    color: ${({ theme }) => theme.neutral.white};
    border-radius: 5px;
    border: none;
    background: ${({ theme }) => theme.button.primary};
    transition: transform 0.1s ease;
  }

  button:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const SectionWrapper = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;
  align-items: center;

  label {
    font-weight: bold;
    font-size: 14px;
  }

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }
`;

export const IntegrationSection = styled.div`
  display: none;
  grid-template-columns: 1.5em 1fr;
  align-items: baseline;
  padding: 0.4rem;

  label {
    font-size: initial;
  }

  input {
    cursor: pointer;
  }
`;
